import BackgroundImageV5 from '@components/imageModules/v5/backgroundImg_v5'
import { IGatsbyImageDataObject } from '@et/types/Gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import React from 'react'
import { twMerge } from 'tailwind-merge'
interface Props {
  image?: IGatsbyImageDataObject
  headlineClasses?: string
  linkClasses?: string
}
export default function Pattern30Day(props: Props) {
  const { image, headlineClasses, linkClasses } = props
  return (
    <BackgroundImageV5
      bgImageClasses='bgImageClasses hidden relative h-[200px] md:block md:absolute md:h-full'
      innerDivClasses='md:min-h-0 lg:min-h-[auto]'
      gatsbyDataImg={image?.gatsbyImageData}
      showBlurImage={true}>
      <div className='relative py-8 et-grid-basic md:py-16 z-3 xl:py-28'>

        <div className='col-span-2 col-start-2 pb-8 md:col-start-3 md:col-span-8 md:pb-0 xl:col-start-3 xl:col-span-6'>
          <h2 className={twMerge('pr-8 text-5xl font-sentinel__SemiBoldItal md:section-h2 xl:text-6xl', headlineClasses)}>14 Day Money Back Guarantee</h2>
        </div>

        <div className='col-span-2 col-start-2 md:col-start-3 md:col-span-6 lg:col-start-4 lg:col-span-5'>
          <p className='mb-4 text-lg lg:text-xl'>I believe so fully in this process and the resources provided within the course, I'm proud to honor my 14 day money back guarantee.</p>

          <p className='mb-4 text-lg lg:text-xl'>If you go through the course and still want to stick with the old way of doing things, send me <span className=''>an email before the 14 days is up and I'll issue a full refund</span>.</p>

          <p>
            <a target="_blank" href='https://every-tuesday.com/terms-conditions/' className={twMerge('italic', linkClasses)}>View our terms and conditions</a>
          </p>

        </div>
      </div>
    </BackgroundImageV5>
  )
}
